<!-- <app-splash-screen></app-splash-screen> -->
<app-loader></app-loader>
<router-outlet></router-outlet>